/* Formatage de la prochaine ouverture d'un restaurant fermé
   (horaires automatiques) : « aujourd'hui à 08:00 », « demain à 08:00 »,
   ou « lundi à 08:00 ». Guinée = UTC toute l'année. */
export function fmtReopen(iso, lang = "fr") {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const hh = `${String(d.getUTCHours()).padStart(2, "0")}:${String(d.getUTCMinutes()).padStart(2, "0")}`;
  const dayDiff = Math.floor((Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) -
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())) / 86400000);
  const fr = dayDiff <= 0 ? "aujourd'hui" : dayDiff === 1 ? "demain"
    : ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"][d.getUTCDay()];
  const en = dayDiff <= 0 ? "today" : dayDiff === 1 ? "tomorrow"
    : ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][d.getUTCDay()];
  return lang === "en" ? `${en} at ${hh}` : `${fr} à ${hh}`;
}
